import * as React from 'react'

import { NextSeo } from 'next-seo'

import * as url from '@bob/url'
import * as ds from '@bob/design-system'

import { SITE_URL } from '@bob/config'

import { MainSection } from './MainSection'
import { ArchiveSection } from './ArchiveSection'
import { SecondaryNewsletterSection } from './SecondaryNewsletterSection'

import { useArchives } from './hooks/useArchives'

export function Newsletter() {
  const archives = useArchives()

  return (
    <>
      <NextSeo
        title="Bien ou bien : la newsletter qui vous aide à mieux consommer"
        description="Chaque vendredi, des conseils, produits et idées pour une consommation plus durable, plus respectueuse des humains et de la planète."
        canonical={SITE_URL + url.newsletter().path}
        openGraph={{
          title: 'Bien ou bien : la newsletter qui vous aide à mieux consommer',
          description:
            'Chaque vendredi, des conseils, produits et idées pour une consommation plus durable, plus respectueuse des humains et de la planète.',
          url: SITE_URL + url.newsletter().path,
          images: [
            {
              alt: 'Bien ou Bien, le magasin où acheter des biens tout simplement bien',
              url: SITE_URL + '/assets/images/inscription-nl-bob-share-opt.jpg',
            },
          ],
        }}
        robotsProps={{
          maxImagePreview: 'large',
        }}
      />
      <ds.Container>
        <MainSection iframe={archives.status === 'success' ? archives.list[0].url : undefined} />
      </ds.Container>
      {archives.status !== 'failure' && (
        <>
          <ArchiveSection archives={archives} />
          <ds.Container>
            <SecondaryNewsletterSection />
          </ds.Container>
        </>
      )}
    </>
  )
}
